import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { Injectable, ComponentRef } from '@angular/core';
import { ComponentPortal } from '@angular/cdk/portal';
import { BehaviorSubject } from 'rxjs';

import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import { LoadingscreenComponent } from 'src/app/components/loadingscreen/loadingscreen.component';
import { MatDialog } from '@angular/material/dialog';
import { CommonMessageDialogComponent } from '../components/common-message-dialog/common-message-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class UxserviceService {
  private overlayref: OverlayRef | undefined;
  private overlayRouteRef: OverlayRef | undefined;
  private currentComponentRef: ComponentRef<LoadingscreenComponent> | undefined;
  private closeTimer: any;

  public vendorTutorialStep$ = new BehaviorSubject<number>(0);

  constructor(
    private snackBar: MatSnackBar,
    private overlay: Overlay,
    private dialog: MatDialog,
  ) {}

  showMessage(
    message: string,
    title?: string,
    type: 'success' | 'error' | 'info' = 'info',
  ) {
    if (type === 'success') {
      this.showSuccess(message, title || 'Success');
      return;
    }

    // Show other types of messages
    this.dialog.open(CommonMessageDialogComponent, {
      data: { message, title, type },
      panelClass: 'message-dialog-panel',
    });
  }


  showSuccess(message: string, title: string = 'Success') {
    this.dialog.open(CommonMessageDialogComponent, {
      data: { message, title, type: 'success' },
      panelClass: 'success-toast-panel',
      position: { top: '85px', right: '20px' },
      hasBackdrop: false, // Toast-like, doesn't need a backdrop
    });
  }

  showError(message: string, title: string = 'Error') {
    this.showMessage(message, title, 'error');
  }

  openSnackBar(message: string, action: string) {
    const lowerMessage = message.toLowerCase();
    if (lowerMessage.includes('error') || lowerMessage.includes('fail') || lowerMessage.includes('incorrect') || lowerMessage.includes('invalid') || lowerMessage.includes('please')) {
      this.showError(message);
    }
    // Suppress all other snackbars as they are "popups that do not require any button to click"
  }
  overlayDefault(msgtoshow: string) {
    return new Promise((resolve, reject) => {
      this.overlayref = this.overlay.create({
        positionStrategy: this.overlay
          .position()
          .global()
          .centerHorizontally()
          .centerVertically(),
        hasBackdrop: true,
        backdropClass: 'loadingScreenClass',
        disposeOnNavigation: true,
      });
      const componentRef = this.overlayref.attach(
        new ComponentPortal(LoadingscreenComponent),
      );
      componentRef.instance.myInput = msgtoshow;
      setTimeout(() => {
        if (this.overlayref) {
          this.overlayref.dispose();
          this.overlayref = undefined;
        }
        resolve(true);
      }, 2000);
    });
  }
  async showRoutingOverlay(msgtoshow: string) {
    this.overlayRouteRef = this.overlay.create({
      positionStrategy: this.overlay
        .position()
        .global()
        .centerHorizontally()
        .centerVertically(),
      hasBackdrop: true,
      backdropClass: 'loadingScreenClass',
      disposeOnNavigation: true,
    });
    const componentRef = this.overlayRouteRef.attach(
      new ComponentPortal(LoadingscreenComponent),
    );
    componentRef.instance.myInput = msgtoshow;
  }
  async closeRoutingOverlay() {
    if (this.overlayRouteRef && this.overlayRouteRef.hasAttached()) {
      this.overlayRouteRef.detach();
      this.overlayRouteRef.dispose();
      this.overlayRouteRef = undefined;
    }
  }

  async showOverlay(msgtoshow: string, showText: boolean = false) {
    console.log(new Date(), msgtoshow);

    const messageToDisplay = showText ? msgtoshow : '';

    // If overlay already exists and is attached, just update the message
    if (this.overlayref && this.overlayref.hasAttached() && this.currentComponentRef) {
      this.currentComponentRef.instance.myInput = messageToDisplay;
      return;
    }

    // Dispose any existing overlay before creating a new one to prevent orphaned overlays
    if (this.overlayref) {
      this.overlayref.dispose();
      this.overlayref = undefined;
    }

    // Cancel any pending closure
    if (this.closeTimer) {
      clearTimeout(this.closeTimer);
      this.closeTimer = undefined;
    }

    this.overlayref = this.overlay.create({
      positionStrategy: this.overlay
        .position()
        .global()
        .centerHorizontally()
        .centerVertically(),
      hasBackdrop: true,
      backdropClass: 'loadingScreenClass',
      disposeOnNavigation: true,
    });
    this.currentComponentRef = this.overlayref.attach(
      new ComponentPortal(LoadingscreenComponent),
    );
    this.currentComponentRef.instance.myInput = messageToDisplay;
  }
  closeOverlay() {
    console.log(new Date(), 'closeoverlayy');

    if (this.closeTimer) {
      clearTimeout(this.closeTimer);
    }

    this.closeTimer = setTimeout(() => {
      if (this.overlayref) {
        this.overlayref.dispose();
        this.overlayref = undefined;
        this.currentComponentRef = undefined;
      }
      this.closeTimer = undefined;
    }, 1500);
  }
  closeOverlayforLogin() {
    console.log(new Date(), 'closeoverlayy');
    setTimeout(() => {
      if (this.overlayref) {
        this.overlayref.dispose();
        this.overlayref = undefined;
      }
    }, 3000);
  }

  instantCloseOverlay() {
    console.log(new Date(), 'instantclose');
    if (this.closeTimer) {
      clearTimeout(this.closeTimer);
      this.closeTimer = undefined;
    }
    if (this.overlayref) {
      this.overlayref.dispose();
      this.overlayref = undefined;
      this.currentComponentRef = undefined;
    }
  }

  showConfirmation(
    message: string,
    title: string = 'Confirm',
    primaryBtn: string = 'Yes',
    secondaryBtn: string = 'No',
  ): Promise<boolean> {
    const dialogRef = this.dialog.open(CommonMessageDialogComponent, {
      data: {
        message,
        title,
        type: 'info',
        primaryButtonText: primaryBtn,
        secondaryButtonText: secondaryBtn,
      },
      panelClass: 'old-confirmation-panel',
      disableClose: true, // Prevent clicking outside to close for confirmation
    });

    return dialogRef.afterClosed().toPromise();
  }

}
